import { defineMessages } from 'react-intl';
export default defineMessages({
  invoicesExportDownloadSuccessful: {
    id: 'InvoicesExport.toast.invoice.download.success',
    defaultMessage: 'The export was successfully processed!'
  },
  invoicesExportDownloadError: {
    id: 'InvoicesExport.toast.invoice.download.error',
    defaultMessage: 'The export failed during processing.'
  },
  invoicesExportEmailSuccessful: {
    id: 'InvoicesExport.toast.invoice.email.success',
    defaultMessage:
      'The export was successfully processed, and the email will be sent out!'
  },
  invoicesExportEmailError: {
    id: 'InvoicesExport.toast.invoice.email.error',
    defaultMessage:
      'The export failed to be processed. No email was or will be sent.'
  },
  error: {
    id: 'InvoicesExport.toast.export.error',
    defaultMessage: 'The invoices failed to be processed.'
  }
});
